if (!customElements.get('quantity-discount-picker')) {
    class QuantityDiscountPicker extends HTMLElement{
        constructor() {
            super();
            this.buttons = this.querySelectorAll(".quantity-button");
            this.quantitySelector = document.querySelector(".product__blocks .quantity__input");
            this.quantityMinus = document.querySelector(".product__blocks .quantity__button[name='minus']");
            this.quantityPlus = document.querySelector(".product__blocks .quantity__button[name='plus']");
        }

        get pdpPriceWrapper() {
            return document.querySelector(".product__blocks .f-price:not(.quantity-discount)");
        }

        get unitPriceWrapper() {
            return document.querySelector(".product__blocks .f-price__unit-wrapper:not(.quantity-discount)");
        }

        get pdpDiscountPriceWrapper() {
            return document.querySelector(".product__blocks .product__block--price .f-price.quantity-discount");
        }

        get discountUnitPriceWrapper() {
            return document.querySelector(".product__blocks .product__block--price .f-price__unit-wrapper.quantity-discount");
        }

        get showSubtotal() {
            return this.dataset.showSubtotal === "true";
        }

        get selectedOption() {
            return this.buttons ? Array.from(this.buttons).find((button) => button.classList.contains("active")) : null;
        }

        get selectedQuantity() {
            return this.selectedOption ? parseInt(this.selectedOption.getAttribute("data-quantity") || "1") : 1;
        }

        get selectedDiscountPrice() {
            // Fallback to original price if no discount option is selected
            if(!this.selectedOption) {
                return this.dataset.productPrice;
            }
            return this.selectedOption.getAttribute(`data-discount-price`);
        }

        get selectedUnitTotalVolume() {
            // Fallback to original price if no discount option is selected
            return this.selectedOption ? parseInt(this.selectedOption.getAttribute(`data-unit-total-volume`)) : null;
        }

        get selectedUnitPrice() {
            // Fallback to original price if no discount option is selected
            if(!this.selectedOption) return this.dataset.productPrice;
            return this.selectedOption.getAttribute(`data-unit-price`);
        }

        get originalPrice() {
            const originalPrice = this.dataset.plainPrice * this?.selectedQuantity / 100;
            if(!this.selectedOption) return originalPrice + " €";
            return this.selectedOption.getAttribute(`data-original-price`);
        }

        connectedCallback() {
            if(this.buttons) {
                this.buttons.forEach((button) => {
                    button.addEventListener("click", () => {
                        this.setQuantity(button); // Set this one first so that setActive gets the correct quantity
                        this.setActive(button);
                    });
                });
            }

            if(this.quantitySelector) {
                this.quantitySelector.addEventListener("change", (event) => {
                    const quantity = event.target.value;
                    if(!quantity || !this.buttons) return;

                    let bestMatch;
                    this.buttons.forEach((button) => {
                        if(Number(quantity) >= Number(button.dataset.quantity)) {
                            bestMatch = button;
                        }
                    });
                    this.setActive(bestMatch);
                });
            }
        }

        setActive(button) {
            if(!this.buttons || !button) return;
            this.buttons.forEach((btn) => btn.classList.remove("active"));
            button.classList.add("active");

            const activeTextElement = this.querySelector("#active-quantity-text");
            if (activeTextElement) {
                activeTextElement.textContent = button.querySelector(".quantity-button__text")?.textContent || "";
            }
            // Reset the price
            if (!button.dataset.discount) {
                this.pdpPriceWrapper?.classList.remove("hidden");
                this.pdpDiscountPriceWrapper?.classList.add("hidden");

                if(this.selectedUnitPrice && this.selectedUnitTotalVolume) {
                    this.unitPriceWrapper?.classList.remove("hidden");
                    this.discountUnitPriceWrapper?.classList.add("hidden");
                }
                return;
            }

            // Update Subtotal price on PDP
            this.updatePriceWrapper(
                this.pdpPriceWrapper,
                this.pdpDiscountPriceWrapper,
                `<div class="quantity-discount f-price f-price--large f-price--on-sale hidden"><div class="f-price__regular"><span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>
                    <span class="f-price-item f-price-item--regular">
                        ${this.dataset.productPrice}
                    </span>
                </div>
                <div class="f-price__sale">
                    <span class="visually-hidden visually-hidden--inline">Verkaufspreis</span>
                    <span class="f-price-item f-price-item--sale">
                    ${this.selectedDiscountPrice}</span>
                    <span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>
                    <span class="f-price-item f-price-item--regular">
                        <s>${this.originalPrice}</s>
                    </span></div>
                </div>`,
                ".f-price-item--sale",
                this.selectedDiscountPrice
            );

            // Update Subtotal price on PDP
            this.updatePriceWrapper(
                this.pdpPriceWrapper,
                this.pdpDiscountPriceWrapper,
                `<div class="quantity-discount f-price f-price--large f-price--on-sale hidden"><div class="f-price__regular"><span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>
                    <span class="f-price-item f-price-item--regular">
                        ${this.dataset.productPrice}
                    </span>
                </div>
                <div class="f-price__sale">
                    <span class="visually-hidden visually-hidden--inline">Verkaufspreis</span>
                    <span class="f-price-item f-price-item--sale">
                    ${this.selectedDiscountPrice}</span>
                    <span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>
                    <span class="f-price-item f-price-item--regular">
                        <s>${this.originalPrice}</s>
                    </span></div>
                </div>`,
                ".f-price-item--regular s",
                this.originalPrice
            );

            if(this.selectedUnitPrice && this.selectedUnitTotalVolume) {
                // Update Unit price on PDP
                this.updatePriceWrapper(
                    this.unitPriceWrapper,
                    this.discountUnitPriceWrapper,
                    `<div class="f-price__unit-wrapper quantity-discount">
                  <span class="visually-hidden">Stückpreis</span>
                  <div class="f-price__unit"><span data-value-volume="">200</span>
                    <span data-unit-volume="">g</span>
                    -
                    <span data-unit-price="">149,75 €</span> <span aria-hidden="true">/</span><span class="visually-hidden">pro&nbsp;</span> <span data-unit-price-base-unit="">kg
                    </span></div>
                </div>`,
                    "span[data-unit-price]",
                    this.selectedUnitPrice,
                );
    
                this.updatePriceWrapper(
                    this.unitPriceWrapper,
                    this.discountUnitPriceWrapper,
                    `<div class="f-price__unit-wrapper quantity-discount">
                  <span class="visually-hidden">Stückpreis</span>
                  <div class="f-price__unit"><span data-value-volume="">200</span>
                    <span data-unit-volume="">g</span>
                    -
                    <span data-unit-price="">149,75 €</span> <span aria-hidden="true">/</span><span class="visually-hidden">pro&nbsp;</span> <span data-unit-price-base-unit="">kg
                    </span></div>
                </div>`,
                    "span[data-value-volume]",
                    this.selectedUnitTotalVolume
                );

            }
        }

        updatePriceWrapper(originalWrapper, discountWrapper, innerHTML, priceSelector, price) {
            if(originalWrapper && !discountWrapper) {
                this.renderInnerHTML(originalWrapper, innerHTML);
            }

            originalWrapper?.classList.add("hidden");
            discountWrapper?.classList.remove("hidden");

            // Update the value if it already exists (e.g. when switching between quantity options)
            const existingDiscountElements = discountWrapper?.querySelectorAll(priceSelector);
            existingDiscountElements?.forEach(el => {
                el.innerHTML = price;
            });
        }

        setQuantity(button) {
            if(!this.quantitySelector) return;
            const { quantity } = button.dataset;

            const difference = this.selectedQuantity - quantity;
            for(let i = 0; i < Math.abs(difference); i++) {
                if(difference < 0) {
                    this.quantityPlus.click();
                    continue;
                }
                this.quantityMinus.click();
            }
        }

        renderInnerHTML(targetElement, innerHTML) {
            const newElement = document.createElement("div");
            newElement.innerHTML = innerHTML;
            targetElement.insertAdjacentHTML("afterend", newElement.innerHTML);
        }
    }
    customElements.define('quantity-discount-picker', QuantityDiscountPicker);
};